import React from "react";

const Loader = () => {
  return (
  <div className="loader-wrapper">
<div class="loader loader_bubble"></div>

  </div>
  )
};

export default Loader;
